import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <AboutSection />
        <RankingSection />
        <CommentsSection />
        <TopicsSection />
        <UpdatesSection />
        <AppSection />
        <IndexSection />
        <ContactSection />
        <CarouselSection />
        <FaqSection />
        <CardsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}